import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { OptionType } from "../../../../Filters/DropDown";
import { Input } from "../../../../Input/Input";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import PopupButtonSection from "./PopupTemplateModal/PopupButtonSection";
import PopupReasonSection from "./PopupTemplateModal/PopupReasonSection";
import { useApi } from "../../../../../hooks/useApi";
import AlertModal from "../../../../Modal/AlertModal";
import Loader from "../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import { IPopupTemplateSave } from "../PopupTemplate";
import PopupContentSection from "./PopupTemplateModal/PopupContentSection";
import PopupTemplateDeleteModal from "./PopupTemplateDeleteModal";
import Blank from "../../../../DefaultStyles/Blank";
import PopupDetailSection from "./PopupTemplateModal/PopupDetailSection";

interface PopupTemplateModalProps extends DefaultModalCommonProps {
  templateData?: IPopupTemplateSave;
}

export default function PopupTemplateModal({
  closeEvent,
  confirmEvent,
  type,
  templateData,
}: PopupTemplateModalProps) {
  console.log(templateData);

  const [modalType, setModalType] = useRecoilState(defaultModalType);

  const [reasonDropdown, setReasonDropdown] = useState<OptionType>({
    value: templateData?.typeString ? templateData?.type + "" : "",
    label: templateData?.typeString ? templateData?.typeString : "선택",
  }); // 팝업 사유
  const [customReasonId, setCustomReasonId] = useState(0); // 사유 추가된 type의 id
  const [title, setTitle] = useState(templateData?.title ?? ""); // 타이틀
  const [desc, setDesc] = useState(templateData?.content ?? ""); // 내용
  const [detailContent, setDetailContent] = useState(
    templateData?.detail ?? ""
  ); // 상세 내용
  const [button, setButton] = useState({
    yes:
      templateData?.buttonName === null || templateData?.buttonName === ""
        ? true
        : false,
    no:
      templateData?.buttonName && templateData?.buttonName !== ""
        ? true
        : false,
  }); // 버튼 유무
  const [buttonName, setButtonName] = useState(
    templateData?.buttonName && templateData?.buttonName !== ""
      ? templateData?.buttonName
      : ""
  ); // 버튼명
  const [buttonLink, setButtonLink] = useState(
    templateData?.buttonLink && templateData?.buttonLink !== ""
      ? templateData?.buttonLink?.split(",")[0] ?? ""
      : ""
  ); // 웹 버튼 링크
  const [appButtonLink, setAppButtonLink] = useState(
    templateData?.buttonLink && templateData?.buttonLink !== ""
      ? templateData?.buttonLink?.split(",")[1] ?? ""
      : ""
  ); // 앱 버튼 링크

  const [askRegModal, setAskRegModal] = useState(false);
  const [reg, setReg] = useState(false); // 팝업 템플릿 등록

  const [getUsingCount, setGetUsingCount] = useState(false); // 팝업 템플릿 카운트
  const [usingTemplateModal, setUsingTemplateModal] = useState(false); // 사용 중인 템플릿 모달
  const [editTemplate, setEditTemplate] = useState(false); // 팝업 템플릿 수정

  const [deleteTemplateModal, setDeleteTemplateModal] = useState(false); // 템플릿 삭제 모달 불러오기

  // 팝업 템플릿 추가
  const { response, error, loading } = useApi({
    method: "post",
    url: reg ? `popup/message` : undefined,
    data: {
      title,
      content: desc,
      detail: detailContent,
      isButton: 1,
      buttonName,
      buttonLink:
        buttonLink !== "" && appButtonLink !== ""
          ? `${buttonLink},${appButtonLink}`
          : "",
      type:
        reasonDropdown?.value === "custom"
          ? customReasonId
          : +reasonDropdown?.value!,
    },
  });

  // 팝업 템플릿 수정
  const {
    response: editRes,
    error: editError,
    loading: editLoading,
  } = useApi({
    method: "post",
    url:
      editTemplate && templateData?.id! > -1
        ? `popup/message/${templateData?.id}`
        : undefined,
    data: {
      title,
      content: desc,
      detail: detailContent,
      isButton: 1,
      buttonName,
      buttonLink:
        buttonLink !== "" && appButtonLink !== ""
          ? `${buttonLink},${appButtonLink}`
          : "",
      type: +reasonDropdown?.value!,
    },
  });

  // 팝업 템플릿 사용 개수
  const {
    response: cntResponse,
    error: cntError,
    loading: cntLoading,
  } = useApi({
    method: "get",
    url:
      getUsingCount && templateData?.id! > -1
        ? `popup/message/${templateData?.id}`
        : undefined,
  });

  useEffect(() => {
    if (response?.status === 200 || editRes?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success(
        `팝업 템플릿이 ${
          modalType === "edit"
            ? "수정"
            : modalType === "input"
            ? "추가"
            : "삭제"
        }되었습니다.`
      );
    }
  }, [response, editRes, modalType]);

  useEffect(() => {
    if (cntResponse?.status === 200 || cntResponse?.status === 201) {
      if (cntResponse?.data?.cnt > 0) {
        setUsingTemplateModal(true);
      } else {
        if (modalType === "edit") {
          setEditTemplate(true);
        } else {
          setDeleteTemplateModal(true);
        }

        setGetUsingCount(false);
      }
    }
  }, [cntResponse]);

  useEffect(() => {
    if (error || editError) {
      toast.error(
        editError?.data ??
          error?.data ??
          `팝업 템플릿 ${
            modalType === "edit" ? "수정" : "추가"
          }에 실패하였습니다.`
      );
      setReg(false);
    }
  }, [error, editError, modalType]);

  useEffect(() => {
    if (cntError) {
      toast.error(
        cntError?.data ??
          "팝업 템플릿 사용 중인 카운트를 가져오는 데에 실패하였습니다."
      );
      setGetUsingCount(false);
    }
  }, [cntError]);

  useEffect(() => {
    setModalType(type);
  }, [type]);

  return (
    <DefaultModalLayout
      modalTitle={`팝업 템플릿 ${
        modalType === "view" ? "보기" : modalType === "edit" ? "수정" : "추가"
      }`}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (modalType === "input") {
          setAskRegModal(true);
        } else if (modalType === "edit") {
          setGetUsingCount(true);
        }
      }}
      confirmDisabled={
        modalType === "input"
          ? reasonDropdown?.value === "" ||
            title === "" ||
            desc === "" ||
            Object.values(button)?.filter((a) => a === true)?.length === 0 ||
            (button.no && buttonName === "")
          : false
      }
      deleteBtnShow={modalType === "view"}
      deleteBtnClickEvent={() => setGetUsingCount(true)}
      leftBottomTime={templateData?.update ?? undefined}
      leftBottomName={templateData?.writer ?? undefined}
    >
      {/* 팝업 사유 */}
      <PopupReasonSection
        reasonDropdown={reasonDropdown}
        setReasonDropdown={setReasonDropdown}
        modalType={modalType}
        setCustomReasonId={setCustomReasonId}
      />

      {/* 타이틀 */}
      <ModalSection>
        <ModalLabel>타이틀 입력</ModalLabel>

        <Input
          placeholder="직접 입력. 40글자 제한"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={40}
          readOnly={modalType === "view" ? true : false}
        />
      </ModalSection>

      {/* 본문 */}
      <PopupContentSection
        modalType={modalType}
        desc={desc}
        setDesc={setDesc}
      />

      {/* 상세 */}
      <PopupDetailSection
        modalType={modalType}
        detailContent={detailContent}
        setDetailContent={setDetailContent}
      />

      {/* 버튼 */}
      <PopupButtonSection
        button={button}
        setButton={setButton}
        buttonName={buttonName}
        setButtonName={setButtonName}
        buttonLink={buttonLink}
        setButtonLink={setButtonLink}
        appButtonLink={appButtonLink}
        setAppButtonLink={setAppButtonLink}
        modalType={modalType}
      />

      <Blank blankHeight={40} marginHeight={40} />

      <>
        {(loading || cntLoading || editLoading) && <Loader />}

        {askRegModal && (
          <AlertModal
            title={`팝업을 등록하시겠습니까?`}
            btnColor={"mint"}
            cancelEvent={() => setAskRegModal(false)}
            confirmEvent={() => {
              setAskRegModal(false);
              setReg(true);
            }}
          />
        )}

        {usingTemplateModal &&
          (modalType === "edit" ? (
            <AlertModal
              title={`현재 해당 템플릿을 ${cntResponse?.data?.cnt}건 사용 중입니다. 그래도 수정하시겠습니까?`}
              cancelEvent={() => {
                setUsingTemplateModal(false);
                setGetUsingCount(false);
              }}
              confirmEvent={() => {
                setGetUsingCount(false);
                setUsingTemplateModal(false);
                setEditTemplate(true);
              }}
              btnColor="mint"
            />
          ) : (
            <AlertModal
              title={`템플릿을 삭제할 수 없습니다.
          해당 템플릿은 ${cntResponse?.data?.cnt}건의 팝업에 사용 중입니다.`}
              customCancelBtn={<></>}
              confirmEvent={() => setUsingTemplateModal(false)}
            />
          ))}

        {/* 팝업 템플릿 삭제 모달 */}
        {deleteTemplateModal && (
          <PopupTemplateDeleteModal
            closeEvent={() => setDeleteTemplateModal(false)}
            confirmEvent={() => {
              closeEvent();
              if (confirmEvent) {
                confirmEvent();
              }
            }}
            templateId={templateData?.id ?? 0}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

const ModalSection = styled.div`
  margin-bottom: 20px;
`;
